import Stimulus from '@root/javascripts/stimulus';

import LoginController from './login_controller';

Stimulus.register('login', LoginController);
